import { GlobalState } from "@/redux/slice/global/types";

const globalInitialState: GlobalState = {
  referer: "direct",
};

export default globalInitialState;
